import React from 'react';
import { Link } from 'react-router-dom';

export default function Disclaimer() {
  return (
    <div className="min-h-screen bg-[#111315] text-white">
      <header className="border-b border-neutral-900 bg-[#111315]/95 backdrop-blur-xl">
        <div className="max-w-6xl mx-auto px-6 py-8 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="HDAlgos logo" className="h-9 w-auto" />
            <span className="text-sm text-neutral-500 tracking-widest uppercase">Disclaimer</span>
          </div>
          <Link to="/" className="text-sm text-neutral-400 hover:text-white transition">
            ← Back to Home
          </Link>
        </div>
      </header>

      <main className="px-6 py-16">
        <div className="max-w-4xl mx-auto space-y-10 text-neutral-300 leading-relaxed text-base">
          <section className="space-y-4">
            <h1 className="text-3xl sm:text-4xl font-black text-white">Risk Disclaimer</h1>
            <p>
              Trading and investing are risky. Many will lose money in connection with trading and investing activities. All
              content on this site is not intended to, and should not be, construed as financial advice. Decisions to buy, sell,
              hold or trade in securities, commodities and other investments involve risk and are best made based on the advice of
              qualified financial professionals. Past performance does not guarantee future results.
            </p>
            <p>
              The risk of loss in trading and investing can be substantial. You should therefore carefully consider whether such
              trading and investing activities are suitable for you in light of your financial condition.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-white">Hypothetical &amp; Simulated Performance Disclaimer</h2>
            <p>
              Hypothetical or simulated performance results have certain limitations. Unlike an actual performance record,
              simulated results do not represent actual trading. Also, since the trades have not been executed, the results may have
              under-or-over compensated for the impact, if any, of certain market factors, including, but not limited to, lack of
              liquidity. Simulated trading programs in general are designed with the benefit of hindsight, and are based on
              historical information. No representation is being made that any account will or is likely to achieve profit or losses
              similar to those shown.
            </p>
            <p>
              In addition, any strategy constructs, optimizations, or backtests displayed on our platform — including those created
              or suggested via our AI backtesting platform — are hypothetical, presented for educational and informational purposes
              only, and are not indicative of future results or performance. Any examples, charts, equity curves, statistics, or
              alerts derived from such strategies are illustrative only and do not guarantee outcomes in live markets.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-white">Market Data &amp; Delays</h2>
            <p>
              Market data used on our website and within our products may include data licensed from third parties. CBOE BZX
              real-time U.S. equities data is licensed from CBOE and provided through BarChart. Real-time futures data is licensed
              from CME Group and provided through BarChart. Select cryptocurrency data, including major coins, is provided through
              CoinAPI. All data is provided “as is” and should be independently verified for trading purposes.
            </p>
            <p>
              Data, calculations, or outputs on our platform may differ from those on other charting or brokerage platforms
              (including TradingView) due to differences in data vendors, time-stamping, rounding, corporate action handling,
              contract specifications, or execution model assumptions. If a strategy or backtest is emulated from our platform to
              TradingView (or another platform), results may differ for these and other reasons.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-white">Alerts &amp; Automation Disclaimer</h2>
            <p>
              Our platform may allow you to create, schedule, export, or route alerts (including via email, mobile notifications,
              webhooks, or other integrations). Alerts are provided solely for informational and educational purposes. Delivery is
              not guaranteed, may be delayed or interrupted, and may fail due to third-party services, connectivity issues, rate
              limits, or other factors outside our control.
            </p>
            <p>
              You are solely responsible for how you use alerts, including any routing to brokerages, automation systems, or
              third-party tools. HDAlgos does not execute trades, does not monitor your accounts, and does not accept responsibility
              or liability for any trading or investment decisions you make in reliance on alerts, signals, webhooks, or any other
              features. None of our features constitute investment advice or personalized investment advice.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-white">Testimonials Disclaimer</h2>
            <p>
              Testimonials appearing on this website may not be representative of other clients or customers and are not a guarantee
              of future performance or success. Any trading results depicted in testimonials are not verified and we have no basis
              for believing that individual experiences depicted are typical considering that results will vary given many factors
              such as skill, risk management, and experience. Trading and investing are very high-risk activities where it is likely
              you will lose money.
            </p>
            <p>
              As a provider of technical analysis tools and strategies, we do not have access to the personal trading accounts or
              brokerage statements of our customers. As a result, we have no reason to believe our customers perform better or worse
              than traders as a whole based on any content, tool, or platform feature we provide.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-white">HDAlgos Is Not an Investment Adviser</h2>
            <p>
              HDAlgos is not registered as an investment adviser with the U.S. Securities and Exchange Commission. Rather, HDAlgos
              relies upon the “publisher's exclusion” from the definition of “investment adviser” as provided under Section
              202(a)(11)(D) of the Investment Advisers Act of 1940 (the “Advisers Act”) and corresponding state laws. As such,
              HDAlgos does not offer or provide personalized investment advice and nothing in these materials should be construed as
              investment advice within the meaning of the Advisers Act.
            </p>
            <p>
              To the extent any of the content, material, information, or any other kind of informational offering published,
              broadcast, or otherwise stated on this, and/or associated websites, may be deemed to be “investment advice”, such
              information is impersonal and not tailored to the investment needs of any specific person. The information contained
              within this, and/or associated websites, is provided for informational and educational purposes only.
            </p>
            <p>
              The information should not be construed as investment or trading advice and is not meant to be a solicitation or
              recommendation to buy, sell, or hold any positions in any indices or financial markets mentioned. The content and
              information provided by HDAlgos, the website, and the products and services of HDAlgos is solely incidental to the
              business and activities of HDAlgos in providing educational tools for technical analysis and a platform for building,
              testing, and analyzing technical analysis strategies (including via our AI backtesting platform).
            </p>
            <p>
              HDAlgos does not, and will not, provide you with any legal, tax, estate planning, or accounting advice, or any advice
              regarding the suitability, profitability, or appropriateness for you of any security, investment, financial product,
              investment strategy, or other matter. The data, content, and information within the tools, scanners, screeners,
              alerts, strategies, and backtests should not be construed as investment or trading advice and is not meant to be a
              solicitation or recommendation to buy, sell, or hold any positions in any securities or to engage in any other
              transaction.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-white">TradingView Disclosure</h2>
            <p>
              Charts used on this site are by TradingView in which the majority of our technical indicators are built on.
              TradingView® is a registered trademark of TradingView, Inc. www.TradingView.com. TradingView® has no affiliation with
              the owner, developer, or provider of the services described herein.
            </p>
            <p>
              HDAlgos is an independent research and analytics service. Despite being founded and operated by former employees of
              Goldman Sachs, it is not affiliated, associated, authorized, endorsed by, or in any way officially connected with
              Goldman Sachs Group, Inc., or any of its subsidiaries or affiliates. All product and company names mentioned are
              trademarks™ or registered® trademarks of their respective holders. Use of them does not imply any affiliation with or
              endorsement by them.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
